<template>
  <div class="home">
    <div class="header">
      <img src="@/assets/home/home_banner.png" class="img-bg" />
      <div class="header-title">{{ title }}</div>
    </div>
    <div class="container">
      <div class="user-box">
        <img src="@/assets/home/user_bg.png" class="img-bg" />
        <div class="user-main" @click="jumpPath('Login')">
          <div class="left">
            <van-image
              round
              width="50"
              height="50"
              fit="cover"
              :src="require('@/assets/info/default_avatar.png')"
              class="user-icon"
            />
            <div class="user-name">{{ loginName || '未登录' }}</div>
          </div>
          <div class="right" v-if="!loginName">去登录</div>
        </div>
      </div>
      <div class="total-box">
        <div class="total" v-for="item in operationInfo" :key="item.describe">
          <div class="num">{{ item.count }}</div>
          <div class="text">{{ item.describe }}</div>
        </div>
      </div>
      <div class="label">常用功能</div>
      <div class="menu-box">
        <div class="menu-item" v-for="(item, index) in listData"
            :key="item.title + index"
            @click.stop="toMenu(item, index)"
          >
          <img :src="item.icon" class="menu-item_icon">
          <div class="title">
            <span>{{ item.title }}</span>
            <span class="badge" v-if="false"> {{ item.badge }}</span>
          </div>
        </div>
      </div>
      <div class="label">信息公开</div>
      <div class="open-box">
        <div class="left bg" :style="{backgroundImage: 'url('+openIcon[0].icon+')'}" @click="jumpPath(openIcon[0])">
          <div class="text">办事指南查询</div>
        </div>
        <div class="right">
          <div class="top bg" :style="{backgroundImage: 'url('+openIcon[1].icon+')'}" @click="jumpPath(openIcon[1])">
            <div class="text">通知公告查询</div>
          </div>
          <div class="bottom bg" :style="{backgroundImage: 'url('+openIcon[2].icon+')'}" @click="jumpPath(openIcon[2])">
            <div class="text">政策法规查询</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-html="footer"></div>
    <van-dialog v-model="showTips" :show-confirm-button=false>
      <div class="tips">
        <div class="close" @click="showTips=false">
          <van-icon name="cross" />
        </div>
        <div class="title">
          <van-icon name="warning-o" />
          建设单位审核认证提示
        </div>
        <p>请先完善账号信息，待账号审核通过后，再进行业务办理</p>
        <van-button type="info" class="btn" @click="$router.push({ name: 'PersonalCenterDetail' })">去完善</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from '@/utils/api/common'
import personApi from '@/utils/api/personCenter'
// import picture from '@/utils/picture'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  name: 'TabbarHomeHome',
  components: {
  },
  mixins: [moduleMixins],
  data() {
    return {
      openIcon: [
        {
          label: '办事指南查询',
          icon: require('@/assets/home/open_1.png'),
          pageName: 'WorkGuideHome',
          pagePath: 'work-guide-home',
        },
        {
          label: '通知公告查询',
          icon: require('@/assets/home/open_2.png'),
          pageName: 'NoticeHome',
          pagePath: 'notice-home',
        },
        {
          label: '政策法规查询',
          icon: require('@/assets/home/open_3.png'),
          pageName: 'PoliciesHome',
          pagePath: 'policies-home',
        },
      ],
      operationInfo: [],
      listData: [],
      accessLink: '', // 登录账户后获取的id
      loginName: null,
      userInfo: { // 用户信息
      }, 
      title: '', //标题
      footer: '', //尾部标题
      showTips: false,
    }
  },
  computed: {
    navTitle() {
      return '首页'
    }
  },
  watch: {
    $route: {
      handler() {
        // 获取小程序返回的token
        // console.log(this.$route.query)
        if(this.$route.query.token) {
          this.$store.state.token = this.$route.query.token
          // let info = this.$store.state.userInfo
          // this.$store.commit('setUserInfo', info)
        }
        // 让登录后返回也能获取数据
        // this.userInfo = this.$store.state.userInfo
        // if(!this.loginName) this.loginName = this.userInfo.loginName
        // console.log('+++++++', this.userInfo)
        // if(JSON.stringify(this.userInfo) == '{}' || this.loginName == null) {
        //   personApi.getLoginUserInfo().then(res => {
        //     console.log('home---getLoginUserInfo---', res)
        //     this.userInfo = res.data
        //     this.$store.commit('setUserInfo', res.data)
        //   })
        // }
        personApi.getLoginUserInfo().then(res => {
          console.log('home---getLoginUserInfo---', res)
          if(res.code==0) {
            this.userInfo = res.data
            // this.loginName = this.userInfo.loginName
            // 如果是建设单位（公司）账户，显示单位名称
            // 如果是个人账户，如果联系人字段不为空则显示联系人字段
            // 如果为空，则显示登陆账户（对于个人账户，注册的时候联系人不是必填）
            if(this.userInfo.accountType == '企业'){
              this.loginName = this.userInfo.DWMC
            }else{// 如果为个人账户
              if(this.userInfo.LXR){
                this.loginName = this.userInfo.LXR
              }else{
                this.loginName = this.userInfo.loginName
              }
            }
            this.$store.commit('setUserInfo', res.data)
          } else {
            this.userInfo = {}
            this.loginName = null
          }
        }).catch(err => {
          console.log(err)
          this.userInfo = {}
          this.loginName = null
        })
      },
      deep: true,
      immediate: true // 第一次赋值也要触发监听
    }
  },
  methods: {
    jumpPath(item) {
      console.log(item)
      if(item=='Login') {
        if(!this.loginName) {
          // 未登录提示
          this.$dialog.confirm({
            title: '—— 温馨提示 ——',
            message: '您还未登录，是否去登录？',
            confirmButtonText: '去登录',
            confirmButtonColor: '#1D84FF'
          })
          .then(() => {
            if (window.__wxjs_environment === 'miniprogram') {
              wx.miniProgram.navigateTo({
                url: '/pages/webPage/webPage?webUrl=login?title=登录'
              })
            } else {
              this.$router.push({
                name: 'Login',
                query: {title: '登录'}
              })
            }
          })
        } else {
          // 登录后点击事件
        }
      } else {
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/webPage/webPage?webUrl=' + item.pagePath
          })
        } else {
          this.$router.push({ name: item.pageName })
        }
      }
    },
    getOperationInfo() {
      api.getOperationInfo().then(res => {
        this.operationInfo = res.data
      })
    },
    getData() {
      // 获取首页菜单数据
      api
        .getHomeConfig()
        .then(res => {
          this.title = res.data.name
          // this.footer = res.data.pz.data[0].WBBT
          // this.$store.state.footerContent = this.footer
          this.listData = []
          res.data.module.data.forEach(item => {
            let obj = {}
            obj.title = item.KPBT
            obj.content = item.KPMS
            obj.id = item.RID
            obj.isLogin = item.SFXYDL
            obj.isMiddle = 0
            if(item.KPKEY=='CHJGML') {
              obj.icon = require('@/assets/home/icon_1.png')
              obj.pageName = 'jobUnitQueryHome'
              obj.pagePath = 'job-unit-query-home'
            }
            if(item.KPKEY=='YXFB') {
              obj.icon = require('@/assets/home/icon_2.png')
              obj.pageName = 'OpinionPublishHome'
              obj.pagePath = 'opinion-publish-home'
            }
            if (item.KPKEY == 'XMWT') {
              obj.icon = require('@/assets/home/icon_3.png')
              obj.pageName = 'ProjectAppointDetail'
              obj.pagePath = 'project-appoint-detail'
            }
            if (item.KPKEY == 'JDCX') {
              obj.icon = require('@/assets/home/icon_4.png')
              obj.pageName = 'projectProgressHome'
              obj.pagePath = 'project-progress-home'
            }
            if (item.KPKEY == 'XMGS') {
              obj.icon = require('@/assets/home/icon_5.png')
              obj.pageName = 'ProjectPublicityList'
              obj.pagePath = 'project-publicity-list'
            }
            if (item.KPKEY == 'MYDPJ') {
              obj.icon = require('@/assets/home/icon_6.png')
              obj.pageName = 'SatisfactionRateList'
              obj.pagePath = 'satisfaction-rate-list'
            }
            this.listData.push(obj)
          })
        })
        .catch(err => {})
    },
    getUserInfo() {
      // 获取用户信息
      let params = {}
      params.accessLink = this.accessLink
      api
        .getLoginToken(params)
        .then(res => {
          // console.log('getUserInfo:', res)
          this.userInfo = res
          this.userName = res.Truename ? res.Truename : '--'
          // localStorage.setItem('userInfo',JSON.stringify(this.userInfo))// 存储用户信息
          localStorage.setItem('token', this.userInfo.token) // 存储token
          // 目前每次登录都重新请求接口，若token过期，返回到
          this.$store.commit('setUserInfo', this.userInfo)
        })
        .catch(err => {
        })
    },
    toMenu(item, index) {
      // 跳转菜单模块
      // if (item.isLogin == '1' && !this.loginName) {
      if (!this.loginName) {
        //需要登录才能跳转
        this.$dialog
          .confirm({
            title: '—— 温馨提示 ——',
            message: '您还未登录，是否去登录？',
            confirmButtonText: '去登录',
            confirmButtonColor: '#1D84FF'
          })
          .then(() => {
            this.login()
          })
        return
      }
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url:
            '/pages/webPage/webPage?webUrl=' +
            item.pagePath +
            '&middle=' +
            item.isMiddle +
            '&title=' +
            item.title
        })
      } else {
        this.$router.push({
          name: item.pageName,
          query: {middle: item.isMiddle, title: item.title}
        })
      }
    },
    login() {
      if (this.$store.state.loginConfig.isHaveThirdLogin == 1) {
        //第三方登录，统一身份登录一定要小程序
        if (window.__wxjs_environment === 'miniprogram') {
          //改变路由，不然不会触发activated
          this.$router.push({name: 'Personal'})
          wx.miniProgram.navigateTo({
            url: '/pages/faceWebview/faceWebview?currentUserType=1'
          })
        } else {
          this.$toast('请使用小程序登录')
        }
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    }
  },
  created() {
    this.getOperationInfo()
    this.getData()
  },
  activated() {
    const token = this.$route.query.token
    const userType = this.$route.query.usertype
    //有值是证明有去人脸识别
    console.log('activated,token', token)
    if (token) {
      let params = {
        access_token: token,
        usertype: userType
      }
      //成功
      api.getUserInfo(params).then(res => {
        console.log('res', res)
        this.$store.commit('setUserInfo', res.data)
        // this.$bus.$emit('btnLogin')
      })
    }
    this.$bus.$emit('tabActive', 0)
  },
  mounted() {
    // 每次从小程序主入口跳转到多测合一首页，都重新获取token，并重新对用户信息，首页菜单接口进行请求

    // 判断帐号信息是否完善
    if(this.loginName && this.userInfo.YHZT == '4') {
      let isAlert = sessionStorage.getItem('isAlert')
      if(!isAlert) {
        // this.$dialog.alert({
        //   title: '建设单位审核认证提示',
        //   message: '请先完善账号信息，待账号审核通过后，再进行业务办理',
        //   theme: 'round-button',
        //   confirmButtonText: '去完善',
        //   confirmButtonColor: '#1D84FF',
        //   messageAlign: 'left'
        // }).then(() => {
        //   this.$router.push({ name: 'PersonalCenterDetail' })
        // })
        this.showTips = true
        sessionStorage.setItem('isAlert', 1)
      }
      
    }
  },
}
</script>

<style lang="scss" scoped>
.home {
  background-color: #fff;
  .header {
    box-sizing: border-box;
    width: 100%;
    position: relative;
    .header-title {
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      font-weight: bold;
      color: #ffffff;
      font-size: 24px;
      width: 100%;
      padding: 0 15px;
      text-align: left;
      box-sizing: border-box;
    }
  }
  .img-bg {
    width: 100%;
    display: block;
  }
}

.container {
  margin: 0px 15px;
  transform: translateY(-30px);
  margin-bottom: -30px;
  .label {
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
}

.user-box {
  position: relative;
  margin-left: -12px;
  margin-right: -12px;
  .user-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 4.2rem;
    padding: 0 30px;
    position: absolute;
    top: 0;
    z-index: 1;
    .left {
      display: flex;
      align-items: center;
    }
    .right {
      color: #1d84ff;
    }
  }
}

.total-box {
  padding: 15px 15px;
  background-color: #F1F3F6;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  .total {
    flex: 1;
    margin-right: 10px;
    text-align: center;
    position: relative;
    ::after {
      content: '';
      width: 1px;
      height: 50px;
      background-color: #D8D8D8;
      position: absolute;
      right: -5px;
      top: 10px
    }
    &:last-child {
      margin-right: 0;
      ::after {
        width: 0;
      }
    }
    .num {
      font-size: 20px;
      margin-bottom: 5px;
      font-weight: bold;
    }
    .text {
      font-size: 14px;
      color: #777;
    }
  }
}

.menu-box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  .menu-item {
    width: 33.3333%;
    text-align: center;
    &_icon {
      width: 60px;
      height: 60px;
    }
    .title {
      font-size: 14px;
      color: #333333;
      line-height: 28px;
      padding-bottom: 15px;
    }
  }
}

.open-box {
  display: flex;
  padding: 20px 0;
  .bg {
    background-position: right;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-size: cover;
    border-radius: 5px;
  }
  .text {
    color: #333;
    padding: 15px;
  }
  .left {
    width: 180px;
    height: 150px;
    margin-right: 10px;
    // background-image: url("@/assets/home/open_1.png");
  }
  .right {
    flex: 1;
    .top {
      width: 100%;
      height: 70px;
      margin-bottom: 10px;
    }
    .bottom {
      width: 100%;
      height: 70px;
    }
  }
}

.footer {
  color: #999;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  padding: 30px 0;
  text-align: center;
}

.tips {
  padding: 18px 20px 22px;
  text-align: center;
  position: relative;
  .close {
    padding: 10px;
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .title {
    text-align: left;
    padding: 10px 0;
    font-weight: 500;
    line-height: 24px;
    i {
      color: #ffb025;
    }
  }
  p {
    line-height: 1.8;
    font-weight: bold;
    color: #323233;
  }
  .btn {
    height: 40px;
    border-radius: 5px;
    padding: 0 20px;
  }
}
</style>
